// extracted by mini-css-extract-plugin
export default {"content":"PreviewBookPage_content__K0Zj1","Book":"PreviewBookPage_Book__L6tYA"};